module.exports = __webpack_public_path__ + "img/g2review.34ce10d6.png";